module.exports = __webpack_public_path__ + "img/wl_prod1_6.db602f94.jpg";